export class Utilities {
    static getUUID() {
        return '_' + Math.random().toString(36).substr(2, 20);
    }
}
